import emailjs from "emailjs-com";

// Single source of truth for the lead-capture backend.
// TODO: when CRM is selected (HubSpot / Pipedrive / Slack webhook), swap
// `sendContactForm` to POST to that endpoint and remove emailjs-com.
const EMAILJS = {
  serviceId: "service_l2jjfbj",
  templateId: "template_frw1ikx",
  publicKey: "QFioY8LqZ3Uf1MhQv",
};

export const sendContactForm = (formEl) =>
  emailjs.sendForm(EMAILJS.serviceId, EMAILJS.templateId, formEl, EMAILJS.publicKey);
